import React, { useEffect, useState } from 'react';
import './FormationAzureAdmin.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionFormationAD from '../../components/FormationsAzureAdmin/IntroSectionFormationAD/IntroSectionFormationAD';
import IntroSectionFormationAD2 from '../../components/FormationsAzureAdmin/IntroSectionFormationAD/IntroSectionFormationAD2';
import IntroSectionFormationAD3 from '../../components/FormationsAzureAdmin/IntroSectionFormationAD/IntroSectionFormationAD3';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import PricingFormationAD from '../../components/FormationsAzureAdmin/PricingFormationAD/PricingFormationAD';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import ParallaxIMG0 from './../../assets/images/nas-synology-1.png';
import ParallaxIMG2 from './../../assets/images/nas-synology-3.png';
import ParallaxIMG1 from './../../assets/images/nas-synology-3.png';
import ExpertiseSection from '../../components/PrivateCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData12 from '../../components/Common/IntroSectionBottom/introSectionData12';
import useSectionRefs from '../../hooks/useSectionRefs';
import ContactComponent from '../../components/Common/ContactComponent/ContactComponent';
import TimelineFormationEntra from '../../components/FormationsEntra/TimelineFormationEntra/TimelineFormationEntra';
import BenefitsPrivateCloud from '../../components/PrivateCloud/ServicesSliderPrivateCloud/BenefitsPrivateCloud';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { contactLinkData } from '../../data/contactLinkData';
import CertificationsSection from '../../components/FormationsEntra/CertificationsSection/CertificationsSection';
import TimelineFormationAD from '../../components/FormationsAzureAdmin/TimelineFormationAD/TimelineFormationAD';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import { useTranslation } from 'react-i18next';
import PricingSectionAzureAdm from '../../components/ui/pricing-section-azure-adm';
import FeaturedSectionStats from '../../components/ui/FeaturedSectionStats';
import { FeaturesSectionWithHoverEffects } from '../../components/ui/feature-section-with-hoover-effect';
import formationADFeatures  from './../../data/features/formationAD';

const FormationsAzureAdmin: React.FC = () => {
    const sectionRefs = useSectionRefs();
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const { t } = useTranslation();

    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };

    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

    

  return (
    <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header title={t('formationAD.header.title', 'Services Managés Azure')} subtitle={t('formationAD.header.subtitle', 'Gestion opérationnelle, surveillance et optimisation')} />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionFormationAD />
      </section>
      <section id="commitment" className="section light commitment-section">
        <IntroSectionFormationAD3 />
      </section>
      <section id="cloud" className="section dark">
        <IntroSectionFormationAD2 />
      </section>
      <section id="pricing" className="section dark">
        <PricingSectionAzureAdm openContactModal={handleOpenContactModal} />
      </section>

      <div className="gradient-bg">
        <section id="start2" className="section dark" ref={sectionRefs.start2}>
          <div className="gradient-bg">
            <TimelineFormationAD />
            <GridPatternCard>
              <GridPatternCardBody>
                <div className="tw-h-[5em]"></div>
              </GridPatternCardBody>
            </GridPatternCard>
          </div>
        </section>
      </div>

      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <ContactLinkSection pageKey="azureAdmin" />
        <Footer />
      </section>
      <ContactComponent 
        isOpen={isContactModalOpen}
        onClose={handleCloseContactModal}
      />
    </div>
  );
};

export default FormationsAzureAdmin;
